import React from 'react';

const BOOKING_URL = process.env.REACT_APP_BOOKING_URL || 'https://agenda.filtrosyaceitesjm.com/login';

const TemplateTrust = ({ data, config }) => {
  const activeServices = Array.isArray(data?.services) && data.services.length > 0
    ? config.services.filter(s => data.services.includes(s.id))
    : config.services.slice(0, 6);

  const primary = data.brand_color_primary || '#1e3a5f';
  const secondary = data.brand_color_secondary || '#2563eb';
  const secondaryLight = secondary + '25';

  return (
    <div className="min-h-screen bg-blue-50 text-slate-800 font-sans">
      {/* Header Info */}
      <div className="text-white py-2 px-6 text-sm hidden md:flex justify-between items-center" style={{ backgroundColor: primary }}>
        <span>📍 {data.address || 'Ubicación'}</span>
        <span>📞 {data.phone || 'Teléfono de contacto'}</span>
      </div>

      {/* Hero Section */}
      <header className="bg-white py-16 px-6 shadow-sm">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12">
          <div className="flex-1">
            <span className="font-bold uppercase tracking-wider text-sm mb-4 block" style={{ color: secondary }}>
              Atención Profesional
            </span>
            <h1 className="text-4xl md:text-5xl font-extrabold mb-6 text-slate-900 leading-tight">
              {data.name || config.defaultTitle}
            </h1>
            <p className="text-lg text-slate-600 mb-8">
              {config.defaultDescription}
            </p>
            <div className="flex gap-4">
              <button
                className="text-white px-6 py-3 rounded-lg font-semibold transition-opacity hover:opacity-90"
                style={{ backgroundColor: secondary, boxShadow: `0 4px 14px ${secondary}50` }}
                onClick={() => { window.location.href = `${data.booking_url || BOOKING_URL}?workshopId=${data.id}&niche=${data.niche}`; }}
              >
                Solicitar Cita
              </button>
            </div>
          </div>
          <div className="flex-1 relative">
            <div className="absolute inset-0 rounded-3xl transform translate-x-4 translate-y-4" style={{ backgroundColor: secondaryLight }}></div>
            <img src={data.hero_image_url || config.images[0].url} alt="Especialista" className="relative rounded-3xl shadow-xl object-cover aspect-[4/3] w-full" />
          </div>
        </div>
      </header>

      {/* Trust Badges */}
      <section className="py-8 text-white" style={{ backgroundColor: secondary }}>
        <div className="max-w-6xl mx-auto px-6 flex flex-wrap justify-center gap-8 md:gap-16 text-center text-sm font-semibold tracking-wide uppercase">
          <span>👨‍⚕️ Especialistas</span>
          <span>⭐ Experiencia</span>
          <span>🏥 Tecnología</span>
          <span>🤝 Compromiso</span>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 px-6 relative overflow-hidden" style={{ background: `linear-gradient(160deg, #eef4ff 0%, #f0f6ff 60%, #e8f0fe 100%)` }}>
        <div className="absolute top-10 right-10 w-80 h-80 rounded-full opacity-15 blur-3xl" style={{ backgroundColor: secondary }}></div>
        <div className="absolute bottom-10 left-10 w-60 h-60 rounded-full opacity-10 blur-3xl" style={{ backgroundColor: primary }}></div>

        <div className="relative max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-slate-900">Areas de Especialidad</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {activeServices.map((service, index) => (
              <div
                key={index}
                className="relative p-6 rounded-2xl transition-all duration-300"
                style={{
                  background: 'rgba(255,255,255,0.6)',
                  backdropFilter: 'blur(20px)',
                  WebkitBackdropFilter: 'blur(20px)',
                  border: `1px solid rgba(255,255,255,0.95)`,
                  boxShadow: `0 4px 20px rgba(0,0,0,0.07), inset 0 1px 0 rgba(255,255,255,1)`,
                }}
              >
                {/* Shine */}
                <div className="absolute inset-0 rounded-2xl pointer-events-none" style={{ background: 'linear-gradient(135deg, rgba(255,255,255,0.50) 0%, transparent 40%)' }}></div>
                <div className="absolute top-0 left-6 right-6 h-px" style={{ background: `linear-gradient(to right, transparent, ${secondary}50, transparent)` }}></div>
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mb-5 text-2xl"
                  style={{
                    background: `linear-gradient(135deg, ${secondary}22, ${secondary}08)`,
                    border: `1px solid ${secondary}25`,
                    color: secondary,
                  }}
                >
                  {service.icon}
                </div>
                <h3 className="text-lg font-bold capitalize mb-2 text-slate-800">{service.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TemplateTrust;
